import { skillEntry, skillType } from "./Types";

export const mySkills: skillEntry[] = [
  {
    name: "Anaconda",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Anaconda.png",
    imgAlt: "Anaconda Logo",
    skillType: skillType.pythonUtility,
  },
  {
    name: "MacOS",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Apple.png",
    imgAlt: "MacOS Logo",
    skillType: skillType.os,
  },
  {
    name: "AWS",
    imgPath: process.env.PUBLIC_URL + "/images/logos/AWS.png",
    imgAlt: "AWS Logo",
    skillType: skillType.deployment,
  },
  {
    name: "Bash",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Bash.png",
    imgAlt: "Bash Logo",
    skillType: skillType.cli,
  },
  {
    name: "Bootstrap",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Bootstrap.png",
    imgAlt: "Bootstrap Software Framework Logo",
    skillType: skillType.softwareFramework,
  },
  {
    name: "C",
    imgPath: process.env.PUBLIC_URL + "/images/logos/C.png",
    imgAlt: "C Programming language Logo",
    skillType: skillType.programmingLanguage,
  },
  {
    name: "C++",
    imgPath: process.env.PUBLIC_URL + "/images/logos/C++.png",
    imgAlt: "C++ Programming language Logo",
    skillType: skillType.programmingLanguage,
  },
  {
    name: "Clojure",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Clojure.png",
    imgAlt: "Clojure Programming language Logo",
    skillType: skillType.programmingLanguage,
  },
  {
    name: "C#",
    imgPath: process.env.PUBLIC_URL + "/images/logos/CSharp.png",
    imgAlt: "C# Programming language Logo",
    skillType: skillType.programmingLanguage,
  },
  {
    name: "CSS3",
    imgPath: process.env.PUBLIC_URL + "/images/logos/CSS3.png",
    imgAlt: "CSS3 Logo",
    skillType: skillType.webDevelopment,
  },
  {
    name: "Django",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Django.png",
    imgAlt: "Django Software Framework Logo",
    skillType: skillType.softwareFramework,
  },
  {
    name: "Docker",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Docker.png",
    imgAlt: "Docker Logo",
    skillType: skillType.deployment,
  },
  {
    name: "ESLint",
    imgPath: process.env.PUBLIC_URL + "/images/logos/ESLint.png",
    imgAlt: "ESLint Logo",
    skillType: skillType.webDevelopment,
  },
  {
    name: "Flask",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Flask.png",
    imgAlt: "Flask Logo",
    skillType: skillType.pythonUtility,
  },
  {
    name: "F#",
    imgPath: process.env.PUBLIC_URL + "/images/logos/FSharp.png",
    imgAlt: "F# Programming language Logo",
    skillType: skillType.programmingLanguage,
  },
  {
    name: "Git",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Git.png",
    imgAlt: "Git Logo",
    skillType: skillType.developmentWorkflow,
  },
  {
    name: "GitHub",
    imgPath: process.env.PUBLIC_URL + "/images/logos/GitHub.png",
    imgAlt: "GitHub Logo",
    skillType: skillType.developmentWorkflow,
  },
  {
    name: "GitLab",
    imgPath: process.env.PUBLIC_URL + "/images/logos/GitLab.png",
    imgAlt: "GitLab Logo",
    skillType: skillType.developmentWorkflow,
  },
  {
    name: "Go",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Go.png",
    imgAlt: "Go Programming language Logo",
    skillType: skillType.programmingLanguage,
  },
  {
    name: "Homebrew",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Homebrew.png",
    imgAlt: "Homebrew Logo",
    skillType: skillType.cli,
  },
  {
    name: "HTML5",
    imgPath: process.env.PUBLIC_URL + "/images/logos/HTML5.png",
    imgAlt: "HTML5 Logo",
    skillType: skillType.webDevelopment,
  },
  {
    name: "Javascript",
    imgPath: process.env.PUBLIC_URL + "/images/logos/JavaScript.png",
    imgAlt: "Javascript Programming language Logo",
    skillType: skillType.programmingLanguage,
  },
  {
    name: "Jira",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Jira.png",
    imgAlt: "Jira Logo",
    skillType: skillType.developmentWorkflow,
  },
  {
    name: "JQuery",
    imgPath: process.env.PUBLIC_URL + "/images/logos/JQuery.png",
    imgAlt: "JQuery Logo",
    skillType: skillType.webDevelopment,
  },
  {
    name: "JSON",
    imgPath: process.env.PUBLIC_URL + "/images/logos/JSON.png",
    imgAlt: "JSON Logo",
    skillType: skillType.fileFormat,
  },
  {
    name: "Jupyter",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Jupyter.png",
    imgAlt: "Jupyter Logo",
    skillType: skillType.pythonUtility,
  },
  {
    name: "Linux",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Linux.png",
    imgAlt: "Linux Logo",
    skillType: skillType.os,
  },
  {
    name: "WSL",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Linux.png",
    imgAlt: "WSL Logo",
    skillType: skillType.os,
  },
  {
    name: "Markdown",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Markdown.png",
    imgAlt: "Markdown Logo",
    skillType: skillType.fileFormat,
  },
  {
    name: "Material UI",
    imgPath: process.env.PUBLIC_URL + "/images/logos/MaterialUI.png",
    imgAlt: "Material UI Logo",
    skillType: skillType.webDevelopment,
  },
  {
    name: "Microsoft SQL Server",
    imgPath: process.env.PUBLIC_URL + "/images/logos/MicrosoftSQLServer.png",
    imgAlt: "Microsoft SQL Server Logo",
    skillType: skillType.databaseDevelopment,
  },
  {
    name: "MySQL Workbench",
    imgPath: process.env.PUBLIC_URL + "/images/logos/MySQL.png",
    imgAlt: "MySQL Workbench Logo",
    skillType: skillType.databaseDevelopment,
  },
  {
    name: ".NET",
    imgPath: process.env.PUBLIC_URL + "/images/logos/NET.png",
    imgAlt: ".NET Software Framework Logo",
    skillType: skillType.softwareFramework,
  },
  {
    name: "ASP.NET",
    imgPath: process.env.PUBLIC_URL + "/images/logos/NET.png",
    imgAlt: "ASP.NET Software Framework Logo",
    skillType: skillType.softwareFramework,
  },
  {
    name: ".NET Core",
    imgPath: process.env.PUBLIC_URL + "/images/logos/NETCore.png",
    imgAlt: ".NET Core Software Framework Logo",
    skillType: skillType.softwareFramework,
  },
  {
    name: "Next.js",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Next.js.png",
    imgAlt: "Next.js Software Framework Logo",
    skillType: skillType.softwareFramework,
  },
  {
    name: "Node.js",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Node.js.png",
    imgAlt: "Node.js Software Framework Logo",
    skillType: skillType.softwareFramework,
  },
  {
    name: "NPM",
    imgPath: process.env.PUBLIC_URL + "/images/logos/NPM.png",
    imgAlt: "NPM Logo",
    skillType: skillType.cli,
  },
  {
    name: "NuGet",
    imgPath: process.env.PUBLIC_URL + "/images/logos/NuGet.png",
    imgAlt: "NuGet Logo",
    skillType: skillType.cli,
  },
  {
    name: "NumPy",
    imgPath: process.env.PUBLIC_URL + "/images/logos/NumPy.png",
    imgAlt: "NumPy Logo",
    skillType: skillType.pythonUtility,
  },
  {
    name: "Pandas",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Pandas.png",
    imgAlt: "Pandas Logo",
    skillType: skillType.pythonUtility,
  },
  {
    name: "Postman",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Postman.png",
    imgAlt: "Postman Logo",
    skillType: skillType.other,
  },
  {
    name: "Powershell",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Powershell.png",
    imgAlt: "Powershell Logo",
    skillType: skillType.cli,
  },
  {
    name: "Pytest",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Pytest.png",
    imgAlt: "Pytest Logo",
    skillType: skillType.pythonUtility,
  },
  {
    name: "Python",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Python.png",
    imgAlt: "Python Programming language Logo",
    skillType: skillType.programmingLanguage,
  },
  {
    name: "Raspberry Pi",
    imgPath: process.env.PUBLIC_URL + "/images/logos/RaspberryPi.png",
    imgAlt: "Raspberry Pi Logo",
    skillType: skillType.other,
  },
  {
    name: "React",
    imgPath: process.env.PUBLIC_URL + "/images/logos/React.png",
    imgAlt: "React Software Framework Logo",
    skillType: skillType.softwareFramework,
  },
  {
    name: "React Native",
    imgPath: process.env.PUBLIC_URL + "/images/logos/React.png",
    imgAlt: "React Native Software Framework Logo",
    skillType: skillType.softwareFramework,
  },
  {
    name: "Redux",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Redux.png",
    imgAlt: "Redux Software Framework Logo",
    skillType: skillType.webDevelopment,
  },
  {
    name: "Rider",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Rider.png",
    imgAlt: "Rider Logo",
    skillType: skillType.ide,
  },
  {
    name: "Rust",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Rust.png",
    imgAlt: "Rust Programming language Logo",
    skillType: skillType.programmingLanguage,
  },
  {
    name: "Sequelize",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Sequelize.png",
    imgAlt: "Sequelize Logo",
    skillType: skillType.databaseDevelopment,
  },
  {
    name: "Slack",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Slack.png",
    imgAlt: "Slack Logo",
    skillType: skillType.communication,
  },
  {
    name: "SQLite3",
    imgPath: process.env.PUBLIC_URL + "/images/logos/SQLite.png",
    imgAlt: "SQLite3 Logo",
    skillType: skillType.databaseDevelopment,
  },
  {
    name: "Streamlit",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Streamlit.png",
    imgAlt: "Streamlit Logo",
    skillType: skillType.pythonUtility,
  },
  {
    name: "Swagger",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Swagger.png",
    imgAlt: "Swagger Logo",
    skillType: skillType.webDevelopment,
  },
  {
    name: "Tailwind CSS",
    imgPath: process.env.PUBLIC_URL + "/images/logos/TailwindCSS.png",
    imgAlt: "Tailwind CSS Logo",
    skillType: skillType.webDevelopment,
  },
  {
    name: "Typescript",
    imgPath: process.env.PUBLIC_URL + "/images/logos/TypeScript.png",
    imgAlt: "Typescript Programming language Logo",
    skillType: skillType.programmingLanguage,
  },
  {
    name: "Ubuntu",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Ubuntu.png",
    imgAlt: "Ubuntu Logo",
    skillType: skillType.os,
  },
  {
    name: "Unity",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Unity.png",
    imgAlt: "Unity Logo",
    skillType: skillType.other,
  },
  {
    name: "Visual Studio",
    imgPath: process.env.PUBLIC_URL + "/images/logos/VisualStudio.png",
    imgAlt: "Visual Studio Logo",
    skillType: skillType.ide,
  },
  {
    name: "Visual Studio Code",
    imgPath: process.env.PUBLIC_URL + "/images/logos/VisualStudioCode.png",
    imgAlt: "Visual Studio Code Logo",
    skillType: skillType.ide,
  },
  {
    name: "Vue.js",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Vue.js.png",
    imgAlt: "Vue.js Software Framework Logo",
    skillType: skillType.softwareFramework,
  },
  {
    name: "Windows",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Windows.png",
    imgAlt: "Windows Logo",
    skillType: skillType.os,
  },
  {
    name: "Xamarin",
    imgPath: process.env.PUBLIC_URL + "/images/logos/Xamarin.png",
    imgAlt: "Xamarin Logo",
    skillType: skillType.softwareFramework,
  },
  {
    name: "XML",
    imgPath: process.env.PUBLIC_URL + "/images/logos/XML.png",
    imgAlt: "XML UI Logo",
    skillType: skillType.fileFormat,
  },
  {
    name: "YAML",
    imgPath: process.env.PUBLIC_URL + "/images/logos/YAML.png",
    imgAlt: "YAML Logo",
    skillType: skillType.fileFormat,
  },
  // Other
  {
    name: "Conda",
    imgPath: "https://docs.conda.io/en/latest/_static/favicon.ico?v=92f50989",
    imgAlt: "Conda Logo",
    skillType: skillType.cli,
  },
  {
    name: "GDAL",
    imgPath: "https://gdal.org/en/stable/_static/gdalicon.png",
    imgAlt: "GDAL Logo",
    skillType: skillType.pythonUtility,
  },
  {
    name: "Emotion",
    imgPath: "https://emotion.sh/logo-96x96.png",
    imgAlt: "Emotion Logo",
    skillType: skillType.webDevelopment,
  },
  {
    name: "Google Docs",
    imgPath:
      "https://www.gstatic.com/images/branding/product/2x/docs_2020q4_48dp.png",
    imgAlt: "Google Docs Logo",
    skillType: skillType.other,
  },
  {
    name: "Google Slides",
    imgPath:
      "https://www.gstatic.com/images/branding/product/2x/slides_2020q4_48dp.png",
    imgAlt: "Google Slides Logo",
    skillType: skillType.other,
  },
  {
    name: "Google Sheets",
    imgPath:
      "https://www.gstatic.com/images/branding/product/2x/sheets_2020q4_48dp.png",
    imgAlt: "Google Sheets Logo",
    skillType: skillType.other,
  },
  {
    name: "Microsoft Word",
    imgPath:
      "https://res.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/word_32x1.svg",
    imgAlt: "Microsoft Word Logo",
    skillType: skillType.other,
  },
  {
    name: "Microsoft PowerPoint",
    imgPath:
      "https://res.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/powerpoint_32x1.svg",
    imgAlt: "Microsoft PowerPoint Logo",
    skillType: skillType.other,
  },
  {
    name: "Microsoft Excel",
    imgPath:
      "https://res.cdn.office.net/files/fabric-cdn-prod_20230815.002/assets/brand-icons/product/svg/excel_32x1.svg",
    imgAlt: "Microsoft Excel Logo",
    skillType: skillType.other,
  },
  {
    name: "Microsoft Teams",
    imgPath:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/c/c9/Microsoft_Office_Teams_%282018%E2%80%93present%29.svg/768px-Microsoft_Office_Teams_%282018%E2%80%93present%29.svg.png",
    imgAlt: "Microsoft Teams Logo",
    skillType: skillType.communication,
  },
  {
    name: "Zoom",
    imgPath:
      "https://static.vecteezy.com/system/resources/previews/012/871/376/non_2x/zoom-logo-in-blue-colors-meetings-app-logotype-illustration-free-png.png",
    imgAlt: "Zoom Logo",
    skillType: skillType.communication,
  },
  {
    name: "OBS Studio",
    imgPath: "https://obsproject.com/assets/images/new_icon_small-r.png",
    imgAlt: "OBS Studio Logo",
    skillType: skillType.other,
  },
  // No image
  {
    name: "Scheme",
    imgPath: undefined,
    imgAlt: undefined,
    skillType: skillType.programmingLanguage,
  },
  {
    name: "Prolog",
    imgPath: undefined,
    imgAlt: undefined,
    skillType: skillType.programmingLanguage,
  },
  {
    name: "Assembly",
    imgPath: undefined,
    imgAlt: undefined,
    skillType: skillType.programmingLanguage,
  },
  {
    name: "SQL",
    imgPath: undefined,
    imgAlt: undefined,
    skillType: skillType.databaseDevelopment,
  },
  {
    name: "Jest",
    imgPath: undefined,
    imgAlt: undefined,
    skillType: skillType.webDevelopment,
  },
];
